module.exports = __webpack_public_path__ + "images/花筑奢pr长图_02视频.jpg?v=da5e472a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_02视频.jpg
 ** module id = 28
 ** module chunks = 1 2
 **/